import React from 'react';

import Icon from '../../../components/AppIcon';



import AiRecommendations from './AiRecommendations';

const RecommendationsTab = ({ userProfile }) => {
  const mockRecommendations = [
    {
      id: 1,
      title: 'École Nationale Supérieure d\'Informatique',
      type: 'Établissement',
      match: '95%',
      reason: 'Correspond parfaitement à votre profil en sciences',
      category: 'Informatique',
      location: 'Rabat'
    },
    {
      id: 2,
      title: 'Filière Sciences de l\'Ingénieur',
      type: 'Programme',
      match: '88%',
      reason: 'Excellente base pour vos objectifs de carrière',
      category: 'Ingénierie',
      location: 'Casablanca'
    },
    {
      id: 3,
      title: 'École Mohammadia d\'Ingénieurs',
      type: 'Établissement',
      match: '82%',
      reason: 'Programme reconnu dans votre domaine d\'intérêt',
      category: 'Ingénierie',
      location: 'Rabat'
    }
  ];

  const getMatchColor = (match) => {
    const percentage = parseInt(match);
    if (percentage >= 90) return 'text-green-600 bg-green-100';
    if (percentage >= 80) return 'text-blue-600 bg-blue-100';
    return 'text-amber-600 bg-amber-100';
  };

  return (
    <div className="space-y-8">
      {/* AI Recommendations Section */}
      <AiRecommendations userProfile={userProfile} />

      <div className="border-t border-border pt-8">
        {/* Traditional Recommendations Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Recommandations Traditionnelles</h3>
            <p className="text-sm text-muted-foreground">Basées sur vos préférences et votre profil</p>
          </div>
          <button className="text-primary hover:text-primary/80 text-sm font-medium">
            Voir tout
          </button>
        </div>

        {/* Recommendations List */}
        <div className="space-y-4">
          {mockRecommendations?.map((rec) => (
            <div key={rec?.id} className="border border-border rounded-lg p-6 hover:border-primary/30 transition-colors">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h4 className="font-semibold text-foreground">{rec?.title}</h4>
                    <span className="px-2 py-1 text-xs font-medium bg-secondary text-secondary-foreground rounded-full">
                      {rec?.type}
                    </span>
                  </div>
                  
                  <p className="text-sm text-muted-foreground mb-3">{rec?.reason}</p>
                  
                  <div className="flex items-center gap-4 text-sm">
                    <div className="flex items-center gap-1">
                      <Icon name="MapPin" size={14} className="text-muted-foreground" />
                      <span className="text-muted-foreground">{rec?.location}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Tag" size={14} className="text-muted-foreground" />
                      <span className="text-muted-foreground">{rec?.category}</span>
                    </div>
                  </div>
                </div>
                
                <div className="text-right">
                  <div className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-semibold ${getMatchColor(rec?.match)}`}>
                    <Icon name="Target" size={14} />
                    {rec?.match}
                  </div>
                  
                  <div className="flex gap-2 mt-3">
                    <button className="p-2 hover:bg-muted rounded-lg transition-colors">
                      <Icon name="Heart" size={16} className="text-muted-foreground hover:text-primary" />
                    </button>
                    <button className="p-2 hover:bg-muted rounded-lg transition-colors">
                      <Icon name="ExternalLink" size={16} className="text-muted-foreground hover:text-primary" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View More */}
        <div className="text-center mt-6">
          <button className="px-6 py-2 border border-border rounded-lg hover:bg-muted transition-colors">
            Voir plus de recommandations
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecommendationsTab;